import { render, staticRenderFns } from "./ClienteModalEdicion.vue?vue&type=template&id=063395f6&scoped=true&"
import script from "./ClienteModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ClienteModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ClienteModalEdicion.vue?vue&type=style&index=0&id=063395f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063395f6",
  null
  
)

export default component.exports